import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/testimonials";
export function TestimonialsSection() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-331" data-mp="1rtbcpipunz00">
      <div className="mx-auto max-w-6xl" data-id="element-332" data-mp="1mvteam9gl269">
        <SectionHeading eyebrow="Feedback about the Blueprint™" title="What nursing professionals say about this learning experience" data-id="element-333" data-mp="1muqn0d884xpt" />

        <div className="mt-12 gap-5 sm:columns-2 lg:columns-3" data-id="element-334" data-mp="1dubouda5vo4w">
          {testimonials.map(t => <figure key={t.name} className="mb-5 break-inside-avoid rounded-3xl bg-white p-6 ring-1 ring-line" data-id="element-335" data-mp="18xbswv7101ri">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-336" data-mp="13zjudibvlhec">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-337" data-mp="2ybzwc6xn29de" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-base leading-relaxed text-ink" data-id="element-338" data-mp="1t8u73t54kf8x">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-line pt-5" data-id="element-339" data-mp="1y9hu83q8gbxv">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-340" data-mp="1jcr5coe6qimi" />
                <div data-id="element-341" data-mp="1oasmh3s1w7vc">
                  <p className="flex items-center gap-1 font-extrabold text-navy" data-id="element-342" data-mp="1ocdfuq2mpkrm">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-brand" aria-label="Verified buyer" data-id="element-343" data-mp="2gyyabzeeicze" />
                  </p>
                  <p className="text-sm text-muted" data-id="element-344" data-mp="22b3fodgu1yjo">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="I want to explore the Blueprint™" data-id="element-345" data-mp="277bshk7k5fno" />
      </div>
    </section>;
}